import React, { useCallback, useState } from 'react';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { CONTAINED_VARIANT, NO_ICON, SIZE_44 } from '@yme/atoms/button';
import { SpinnerLoader } from '@yme/atoms/spinner-loader';
import { setIsModalShowed } from '@yme/modals/actions';
import { MODALS } from '@yme/modals/constants';
import { FormField, FormFieldType } from '@yme/molecules/form-field';
import { useTranslation } from '@yme/services/i18n';
import { DigitalDataMutation, setDigitalData } from '@yme/utils/common';
import { regExpValidationEmail } from '@yme/utils/regEx';
import { NewslettersFormHelper } from './NewslettersFormHelper';
import { setNewsletterEmail } from './redux/actions';
import { getNewsLetterIsLoading } from './redux/selectors';
import { ButtonStyled, NewslettersDescriptionStyled, NewslettersSubscribeStyled, NewslettersTitleStyled, } from './styled';
const initialValues = {
    email: '',
};
export function Newsletters() {
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const isLoading = useSelector(getNewsLetterIsLoading);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const handleSubmit = useCallback(({ email }, { resetForm }) => {
        dispatch(setIsModalShowed({
            type: MODALS.NEWSLETTER_MODAL,
        }));
        dispatch(setNewsletterEmail(email));
        setDigitalData(DigitalDataMutation.EMAIL_SUBSCRIPTION, null);
        resetForm();
    }, [dispatch]);
    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .required(t('newsletter_enterYourEmail_message'))
            .matches(regExpValidationEmail, t('newsletter_pleaseEnterValidAddress_message')),
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Formik, { initialValues: initialValues, validationSchema: validationSchema, validateOnBlur: false, validateOnChange: isFormSubmitted, onSubmit: handleSubmit },
            React.createElement(Form, null,
                React.createElement(NewslettersTitleStyled, null, t('footerMenu_newsletter_title')),
                React.createElement(NewslettersDescriptionStyled, { as: "p" }, t('footerMenu_newsletter_description')),
                React.createElement(NewslettersSubscribeStyled, null,
                    React.createElement(FormField, { isFullWidth: true, isValidateOnBlur: true, name: "email", fieldType: FormFieldType.INPUT, placeholder: t('footerMenu_newsletterInput_placeholder') }),
                    React.createElement(ButtonStyled, { buttonVariant: CONTAINED_VARIANT, hasIconButton: NO_ICON, size: SIZE_44, label: t('footerMenu_newsletterButton_label'), type: "submit" })),
                React.createElement(NewslettersFormHelper, { setIsFormSubmitted: setIsFormSubmitted }))),
        React.createElement(SpinnerLoader, { fullWidth: true, isLoading: isLoading })));
}
